import { render } from "./CardTemplate.vue?vue&type=template&id=240c32e6&scoped=true"
import script from "./CardTemplate.vue?vue&type=script&lang=js"
export * from "./CardTemplate.vue?vue&type=script&lang=js"

import "./CardTemplate.vue?vue&type=style&index=0&id=240c32e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240c32e6"]])

export default __exports__